import { Fragment, type FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';

import { getLearningLanguageLabel } from '../helpers';

// Shown while editing a translation that has no text yet. Each language is a
// link that switches the editor to the translation that holds the original text.
export const TranslationOriginHint: FunctionComponent<{
    readonly languages: readonly string[];
    readonly onSelectLanguage: (language: string) => void;
}> = ({ languages, onSelectLanguage }) => {
    const translate = useTranslate();

    return (
        <p
            className="m-0 flex flex-wrap items-center gap-xs text-body-xs text-text-secondary"
            data-testid="translation-origin-hint"
        >
            {translate('pages.learning-opportunities.translation-original-hint')}
            {languages.map((code, index) => (
                <Fragment key={code}>
                    {index > 0 && <span aria-hidden="true">,</span>}
                    <Button
                        className="!p-0 !text-body-xs underline"
                        variant="link"
                        onClick={() => onSelectLanguage(code)}
                    >
                        {getLearningLanguageLabel(code, translate) ?? code}
                    </Button>
                </Fragment>
            ))}
        </p>
    );
};
